import "./index.css";
import { useEffect, useMemo } from "react";
import { UsersRepository } from "@/api/users/repository";
import { UsersService } from "@/api/users/service";
import { PrivacyConsentModal } from "@/components/PrivacyConsent/PrivacyConsentModal";
import { useAppStore } from "@/store/app/slice";
import { UserOnboardingStatus } from "@/types/users";
import { useBoolean } from "@/ui-kit";
import { getTenantFromUrl } from "@/utils/getTenantFromUrl";
import { serverErrorHandler } from "@/utils/serverErrorHandler";

export const PrivacyConsent = () => {
  const { value: show, setTrue: open, setFalse: dismiss } = useBoolean(false);
  const user = useAppStore((s) => s.user);
  const isOnboarded =
    user?.onboardingStatus === UserOnboardingStatus.DetailsProvided;
  const hasTenant = !!getTenantFromUrl();

  const usersRepository = useMemo(() => {
    return new UsersRepository(new UsersService());
  }, []);

  useEffect(() => {
    if (!isOnboarded || !hasTenant) return;

    usersRepository
      .getRequiresReconsent()
      .then((requiresReconsent) => {
        if (requiresReconsent) {
          open();
        }
      })
      .catch(serverErrorHandler());
  }, [isOnboarded, hasTenant, usersRepository, open]);

  if (!show) {
    return null;
  }

  return <PrivacyConsentModal onSuccess={dismiss} />;
};
